import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeCategory: null,
  completedCategories: [],
  currentSection: 0,
  questionsBySection: [],
  answers: [],
  currentQuestionIndex: 0,
  profile: null,
  confidence: null,
  blend: null,
  isSubmitted: false,
};

const forcedChoiceQuizSlice = createSlice({
  name: 'forcedChoiceQuiz',
  initialState,
  reducers: {
    setForcedChoiceQuestions: (state, action) => {
      state.questionsBySection = action.payload;
      state.answers = [];
      state.currentQuestionIndex = 0;
      state.currentSection = 0;
      state.isSubmitted = false;
    },
    preloadForcedChoiceAnswers: (state, action) => {
      state.answers = action.payload;
    },
    selectForcedChoiceAnswer: (state, action) => {
      const { questionId, selectedOption } = action.payload;
      const existing = state.answers.find(a => a.questionId === questionId);
      if (existing) {
        existing.selectedOption = selectedOption;
      } else {
        state.answers.push({ questionId, selectedOption });
      }
    },
    goToNextForcedChoiceQuestion: (state) => {
      const current = state.questionsBySection[state.currentSection] || [];
      if (state.currentQuestionIndex < current.length - 1) {
        state.currentQuestionIndex++;
      }
    },
    goToPreviousForcedChoiceQuestion: (state) => {
      if (state.currentQuestionIndex > 0) {
        state.currentQuestionIndex--;
      }
    },
    goToSpecificForcedChoiceQuestion: (state, action) => {
      const i = action.payload;
      const current = state.questionsBySection[state.currentSection] || [];
      if (i >= 0 && i < current.length) {
        state.currentQuestionIndex = i;
      }
    },
    goToForcedChoiceSection: (state, action) => {
      state.currentSection = action.payload;
      state.currentQuestionIndex = 0;
    },
    setActiveCategory: (state, action) => {
      state.activeCategory = action.payload;
    },
    addCompletedCategory: (state, action) => {
      const cat = action.payload;
      if (!state.completedCategories.includes(cat)) {
        state.completedCategories.push(cat);
      }
    },
    setCompletedCategories: (state, action) => {
      state.completedCategories = action.payload;
    },
    setTraitAssessmentResults: (state, action) => {
      const { profile, confidence, blend } = action.payload;
      state.profile = profile;
      state.confidence = confidence;
      state.blend = blend;
      state.isSubmitted = true;
    },
    resetForcedChoiceQuiz: () => initialState,
    resetQuizProgress: (state) => {
      state.activeCategory = null;
      state.questionsBySection = [];
      state.answers = [];
      state.currentQuestionIndex = 0;
      state.currentSection = 0;
      state.isSubmitted = false;
    }
  },
});

export const {
  setForcedChoiceQuestions,
  preloadForcedChoiceAnswers,
  selectForcedChoiceAnswer,
  goToNextForcedChoiceQuestion,
  goToPreviousForcedChoiceQuestion,
  goToSpecificForcedChoiceQuestion,
  goToForcedChoiceSection,
  setTraitAssessmentResults,
  setActiveCategory,
  addCompletedCategory,
  setCompletedCategories,
  resetForcedChoiceQuiz,
  resetQuizProgress,
} = forcedChoiceQuizSlice.actions;

export default forcedChoiceQuizSlice.reducer;